import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JdInputDirective } from './jd-input.directive';
import { JdInputGroupComponent } from './jd-input-group.component';
import { FormsModule } from '@angular/forms';

const EXPORT_DEC = [
  JdInputDirective,
  JdInputGroupComponent
];

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [...EXPORT_DEC],
  exports: [...EXPORT_DEC]
})
export class JdInputModule {}
